<template>
</template>
<script>
export default {
    data: () => ({
        states: [],

    }),
    methods: {
        async getStates() {
            const { data } = await axios.get('/states')
            this.states = data
            this.states[33] = 'Mi Estado no aparece';
        }
    },
    async mounted() {
        await this.getStates();
        if(!this.$cookies.get('stateUser')) {
            this.$swal({
                title: '¿De qué estado nos visitas?',
                input: 'select',
                inputOptions: this.states,
                inputPlaceholder: 'Seleccionar estado...',
                willOpen: function(ele) {
                    $(ele).find('select.swal2-select').toggleClass('form-input my-6 swal2-select-override')
                    $(ele).find('button.swal2-confirm').toggleClass('w-full')
                    $(ele).find('div.swal2-content').toggleClass('swal2-content')
                },
                allowOutsideClick: false,
                allowEscapeKey: false,
                showCancelButton: false,
                showConfirmButton: true,
                confirmButtonText: 'Aceptar',
                inputValidator: function (value) {
                    return new Promise(function (resolve, reject) {
                    if (value !== '') {
                        resolve();
                    } else {
                        document.querySelector('.swal2-confirm').disabled = false
                        resolve('Selecciona un estado.');
                    }
                    });
                }
            }).then((result) => {
                this.$cookies.remove('userState')
                this.$cookies.set("stateUser", result.value, "15d")
                window.location.reload()
            });
        }
    }
};
</script>

<style lang="scss">
/**
 * swiper class native
 * overwrite the display type of the car mark options at the top of the car cards
 *
 */
.swiper-container {
    max-height: 100vh;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 0;
}

.swal2-select-override {
    font-size: 1rem;
	background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEwIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM5RUEwQTUiIGQ9Ik0zLjA0NSAwbDIuOTM0IDIuOTM0TDAgMy4wNDUgMy4wNDUgMHptLS4xMDIgOS45OThMMCA3LjA1NWw1Ljk5Ny0uMTEyLTMuMDU0IDMuMDU1eiIvPjwvc3ZnPg==") !important;
	background-position: calc(100% - 7px) 50%;
	background-repeat: no-repeat;
	background-size: 7px;
	overflow: hidden;
	padding-right: 20px;
	cursor: pointer;
}

.swiper-wrapper {
    // height: 50vh;

    @media screen and (min-width: 1024px) {
        height: calc(100vh - (266px + 74px));
    }
}

.home__hero {
    height: 50vh;
    margin: 0px;
    @media screen and (min-width: 1024px) {
        height: calc(100vh - (266px + 74px));
    }
}
.swal2-validation-message {
    margin: -1em -0em !important;
}
</style>

<style lang="scss" scoped>

.main_slider_modified {
    // max-height: 75vh;

    @media screen and (min-width: 1366px) {
        max-height: 100%;
    }
}
#filters_headers_container {
    color: #fff;
    >h2 {
        font-family: 'montserrat-bold';
        font-size: calc(2vw + 10px);
        @media only screen and (max-width: 540px) {
            font-size: calc(2.3vw + 10px);
        }
    }
    >p {
        font-size: calc(1vw + 10px);
        @media only screen and (max-width: 540px) {
            font-size: calc(1.4vw + 10px);
        }
    }
}

#slider_buttons_container {
    font-family: 'montserrat-bold';
    z-index: 9999;
    font-size: 1rem;
    justify-content: center;
    // width: 65%;
    // max-width: 800px;
    width: 678px;
    flex-wrap: wrap;
    margin: auto;

    & > div {
        flex-direction: column;
        width: 100%;

        & > a {
            width: 100%;
            &:first-child {
                margin-bottom: 0.5rem;
                @media screen and (min-width: 1024px) {
                    margin-bottom: 0;
                }
            }
            @media screen and (min-width: 1024px) {
                width: 49%;
            }
        }

        @media screen and (min-width: 1024px) {
            flex-direction: row;
        }
    }

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        height: 242px;
        align-items: center;
        width: 100%;
        flex-wrap: nowrap;
    }

    @media only screen and (max-width: 420px) {
        height: 25vh;
        font-size: calc(1vw + 9px);
    }

/*     a {
        width: 330px;
        @media screen and (min-width: 420px) and (max-width: 519px) {
            width: 90%;
        }
        @media screen and (min-width: 520px) and (max-width: 767px) {
            width: 70%;
        }
        @media only screen and (max-width: 420px) {
            width: 98%;
            max-height: 43.8px;
        }
    } */
}

#button-buy {
    width: 100% !important;
/*     width: 678px !important;

    @media screen and (min-width: 420px) and (max-width: 519px) {
        width: 90% !important;
        }
    @media screen and (min-width: 520px) and (max-width: 767px) {
        width: 70% !important;
    }
    @media screen and (min-width: 767px) and (max-width: 1092px) {
        width: 330px !important;
    }
    @media only screen and (max-width: 420px) {
        width: 98% !important;
        max-height: 43.8px;
    } */
}


.bottom-slider-icons {
    width: 100%;
    background-color: #000;
    // padding-bottom: 10px;
    font-weight: 600;
    position: relative;
    z-index: 2;
    height: 266px;
    // margin-top: -200px;
    display: none;
    // position: absolute;
    bottom: 0;

    @media screen and (min-width: 1024px) {
        display: block;
        // margin-top: -260px;
    }
}

/* .bottom-slider-icons-mobile {
    height: 50vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    > a {
        font-size: 0.8rem;
    }
} */

.bottom-slider-icons-mobile {
    width: 100%;
    background-color: #000;
    // padding-bottom: 20px;
    font-weight: 600;
    position: relative;
    z-index: 2;
    // margin-top: -200px;
    // padding-bottom: 20px;
    bottom: 0;
    // position: absolute;

    height: 50vh;
    @media screen and (min-width: 1024px) {
        height: calc(100vh - (220px + 74px));
    }

    @media screen and (min-width: 1024px) {
        display: none;
        // margin-top: -260px;
    }

    > a {
        > h3 {
            font-size: 0.6rem;
        }
    }

    > div > div > div > div {
        color: #fff;
        position: relative;
        // display: grid;
        max-width: 33.33333%;
        padding-top: 5px;
        // grid-template-columns: repeat(auto-fit, 200px);
        // gap: 10px;
        // justify-content: center;
        // justify-items: center;
        border-bottom: 1.5px solid #DBFE54;
        text-align: center;

        > a {
            text-transform: uppercase;
            // border-bottom: 1.5px solid #DBFE54;
            text-align: center;
            margin: 25px 0;

            > img {
                margin-bottom: 20px;
                width: 50px;
            }

            > h3 {
                font-size: 0.6rem;
                margin-bottom: 0;
            }
        }
    }

    > .bottom-slider-icons-mobile-content {
        transform: translateY(calc(50% + 31.5px));

        > .swiper-container {
            margin-bottom: 15px;
        }
    }

    .swiper-button-prev, .swiper-button-next {
        top: 50%;
        transform: translateY(-50%);
    }
}

.bottom-slider-icons > div {
    color: #fff;
    position: relative;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(auto-fit, 12%);
    gap: 10px;
    justify-content: center;
    justify-items: center;
    > a {
        text-transform: uppercase;
        border-bottom: 1.5px solid #DBFE54;
        text-align: center;
        margin: 25px 0;

        > img {
            margin-bottom: 20px;
            width: 40%;
        }

        > h3 {
            margin-bottom: 0;
            font-size: 16px;
        }
    }

    @media screen and (min-width: 1600px) {
        margin: 0 auto;
        width: 90%;
    }
}


.bottom-slider-icons > a {
    text-transform: none;
    display: block;
    margin: 10px auto;
    font-size: 16px;
}
</style>


